import React, { Suspense } from 'react';
import { memberId } from '@trello/session-cookie';
import { useLazyComponent } from '@trello/use-lazy-component';

export const Banners = () => {
  const AtlassianAccountOnboardingBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-onboarding-banner" */ 'app/src/components/AtlassianAccountOnboardingBanner'
      ),
    { namedImport: 'AtlassianAccountOnboardingBanner' },
  );
  const EmailHygieneBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "email-hygiene-banner" */ 'app/src/components/EmailHygieneWizard'
      ),
    { namedImport: 'EmailHygieneBanner' },
  );
  const AtlassianAccountMigrationBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-migration-banner" */ 'app/src/components/AtlassianAccountMigration'
      ),
    { namedImport: 'AtlassianAccountMigrationBanner' },
  );

  // Don't render any of the banners if the user isn't logged in
  if (!memberId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AtlassianAccountOnboardingBanner />
      <EmailHygieneBanner />
      <AtlassianAccountMigrationBanner />
    </Suspense>
  );
};
